import toast from "react-hot-toast";
import * as api from "../Api";
export const createOutstandingDebit = (postData) => async (dispatch) => {
  let creatingId;
  try {
    creatingId = toast.loading("Submitting debit outstandings....");
    const { data } = await api.createDebits(postData);
    dispatch({ type: "CREATE_OUTSTANDING_DEBIT", payload: data });
    toast.remove(creatingId);
    toast.success("Debit outstandings successfully submitted");
  } catch (error) {
    toast.remove(creatingId);
    toast.error(error.message);
  }
};
export const updateOutstandingDebit = (id, postData) => async (dispatch) => {
  let updatingId;
  try {
    updatingId = toast.loading("Saving changes...");
    const { data } = await api.updateDebits(id, postData);
    dispatch({ type: "OUTSTANDING_UPDATE_DEBIT", payload: data });
    toast.remove(updatingId);
    toast.success("Changes updated successfully");
  } catch (error) {
    toast.remove(updatingId);
    toast.error(error.message);
  }
};
